export default class MyDragImage {
  element: Element | null = null;
  startX: number = 0;
  endX: number = 0;
  startY: number = 0;
  endY: number = 0;
  parentX: number = 0;
  parentY: number = 0;
  distanceX: number = 0;
  distanceY: number = 0;
  maxHeight: number = 0;
  maxWidth: number = 0;

  constructor(evt: Element | undefined) {
    this.init(evt);
  }

  init(evt: any): void {
    this.mousedown(evt);
  }

  public mousedown(evt: any): void {
    // target.onmousedown = (ev: any) => {
    // 这里需要用事件委托做拖拽了
    document.onselectstart = function() {
      return false;
    }; //解决拖动会选中文字的问题
    evt.target.onselectstart = function() {
      return false;
    };
    document.ondragstart = function() {
      return false;
    };
    evt.target.ondragstart = function() {
      return false;
    };
    this.startX = evt.clientX;
    this.startY = evt.clientY;
    this.parentX = evt.target.offsetLeft;
    this.parentY = evt.target.offsetTop;
    evt.target.style.position = 'absolute';
    evt.target.style.left = this.parentX + 'px';
    evt.target.style.top = this.parentY + 'px';
    // console.log('图片按下2hahah22了', evt.target.offsetTop, evt.target.offsetLeft);
    this.mousemove(evt.target);
    this.mouseup(evt.target);
    // };
  }

  public mousemove(target: any): void {
    target.onmousemove = (ev: any) => {
      this.mousemovehandle(ev, target);
    };
  }

  public mousemovehandle(ev: any, target: any): void {
    this.distanceX = ev.clientX - this.startX;
    this.distanceY = ev.clientY - this.startY;
    target.style.position = 'absolute';
    target.style.zIndex = 99;
    target.style.left = this.distanceX + this.parentX + 'px';
    target.style.top = this.distanceY + this.parentY + 'px';
    // 为了答题卡拖拽随着更新top值 对应 增加image父元素p标签的height值
    // if(target.parentNode.tagName == "P") {
    //   target.parentNode && (target.parentNode.style.height = this.distanceY + this.parentY + target.offsetHeight+ 'px');
    // } else {
    //   target.parentNode.parentNode && (target.parentNode.parentNode.style.height = this.distanceY + this.parentY + target.offsetHeight+ 'px');
    // }
  }

  public mouseup(target: any): void {
    document.onmouseup = (ev: any) => {
      target.onmousemove = null;
      target.onmousedown = null;
      this.startX = 0;
      this.startY = 0;
    };
    target.onmouseup = (ev: any) => {
      target.onmousemove = null;
      target.onmousedown = null;
    };
  }

  public setMaxHeight(height: number): void {
    this.maxHeight = height;
  }
  public setMaxWidth(width: number): void {
    this.maxWidth = width;
  }
}
